import React, { Component } from "react";
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { LocalizeProvider } from "react-localize-redux";
import CircularProgress from '@material-ui/core/CircularProgress';

import Router from "./Router";
// import RouterMultiplePlaces from "./RouterMultiplePlaces";
import Utils from "./utils/Utils";
import MetaAndOg from './common/MetaAndOg';
import AddToHomeScreen from './common/AddToHomeScreen';
import { changeLanguage } from './language/actions/language.action'
import { getAllProducts } from './products/actions/products.action';
import { getCategoriesHierarchy } from './categories/actions/categories.action';

import { withTracking } from 'react-tracker';// We created this function earlier at (3.)import { pageViewEvent} from '../tracking/events';
import { pageView } from './tracking/events/productEvents';
// import Sound from 'react-sound'; 
// import soundfile from './files/got-it-done.mp3'
import TrackTimeSpentOnPageComponent from './tracking/TrackTimeSpentOnPageComponent';
import Auth from './utils/Auth';
import { startDatecsEndOfDayPoller, stopDatecsEndOfDayPoller } from './payments/datecs/datecsEndOfDay';
import { captureUtmFromUrl, saveUtmToCookie } from "./utils/utm";

const styles = theme => ({
  pageContainer: {
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',

    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updated: false,
      // soundStatus: Sound.status.PLAYING
    }
  }


  // Configure the client's own tracking (per-place settings) once settings are
  // loaded. This registers automatic PageView tracking to the client's accounts.
  // The Purchase / conversion events themselves are fired from
  // products.action.js (trackClientPurchase) on a successful order.
  // Runs at most once per page load (guarded by _clientTrackersConfigured).
  //   - google_ads_conversion_id : Google Ads (AW-XXX[/label]) or a single GA4 tag
  //   - client_ga4_id            : client's own Google Analytics 4 (G-XXX)
  //   - client_facebook_pixel_id : client's own Meta/Facebook pixel
  configureClientTrackers() {
    if (this._clientTrackersConfigured) return;

    const googleAdsId = Utils.getSetting('google_ads_conversion_id');
    const clientGa4Id = Utils.getSetting('client_ga4_id');
    const clientFbPixelId = Utils.getSetting('client_facebook_pixel_id');

    // Wait until settings have actually loaded (any tracker configured).
    if (!googleAdsId && !clientGa4Id && !clientFbPixelId) return;

    this._clientTrackersConfigured = true;

    // Google tags — base gtag.js lib is already loaded in index.html, so
    // configuring an extra target id is enough to start PageView tracking.
    // `config` needs only the base account id — strip any conversion label the
    // admin value may carry (AW-123/label or AW-123,label).
    if (typeof window.gtag === 'function') {
      if (googleAdsId) {
        const baseId = String(googleAdsId).split(/[,/]/)[0].trim();
        window.gtag('config', baseId);
        console.log('[Client Tracking] PageView — Google tag configured:', baseId);
      }
      if (clientGa4Id) {
        const ga4Id = String(clientGa4Id).replace(/\s+/g, '');
        window.gtag('config', ga4Id);
        console.log('[Client Tracking] PageView — GA4 tag configured:', ga4Id);
      }
    }

    // Client's own Meta/Facebook pixel — base fbq lib is loaded in index.html.
    // trackSingle keeps PageView scoped to the client's pixel only, so tabl's
    // global pixel (2912758035505954) is untouched.
    if (clientFbPixelId && typeof window.fbq === 'function') {
      const fbId = String(clientFbPixelId).replace(/\s+/g, '');
      window.fbq('init', fbId);
      window.fbq('trackSingle', fbId, 'PageView');
      console.log('[Client Tracking] PageView — Facebook pixel configured:', fbId);
    }
  }

  componentDidMount() {
    // this.props.trackPageView(this.props.pageId, this.props.userId)

    this.configureClientTrackers();

    this.setUtmCookie();

    // Periodic version check - detect deploys while tab is open
    this._versionCheckInterval = setInterval(() => {
      fetch('/version.json?_t=' + Date.now())
        .then(r => r.json())
        .then(data => {
          if (!data || !data.version) return;
          var stored = localStorage.getItem('app_build_version');
          if (stored && stored !== data.version) {
            localStorage.setItem('app_build_version', data.version);
            window.location.reload();
          }
        })
        .catch(() => {});
    }, 5 * 60 * 1000); // every 5 minutes

    // Kiosk-only: poll for remote Datecs POS End-of-Day requests and run them
    // on the local terminal. No-op unless in kiosk mode.
    startDatecsEndOfDayPoller(() => this.props.translations);

    document.onreadystatechange = function () {
      var state = document.readyState
      if (state == 'interactive') {
        document.getElementById('root').style.visibility = "hidden";
      } else if (state == 'complete') {
        document.getElementById('root').style.visibility = "visible";
        var fadeTarget = document.getElementById("load");
        var fadeEffect = setInterval(function () {
          if (!fadeTarget.style.opacity) {
            fadeTarget.style.opacity = 1;
          }
          if (fadeTarget.style.opacity > 0) {
            fadeTarget.style.opacity -= 0.1;
          } else {
            clearInterval(fadeEffect);
            document.getElementById('load').style.visibility = "hidden";
          }
        }, 20);
      }
    };
  }

  componentWillUnmount() {
    if (this._versionCheckInterval) clearInterval(this._versionCheckInterval);
    stopDatecsEndOfDayPoller();
  }

  componentWillReceiveProps(nextProps) {
    // var placesCount = nextProps.places.length;

    // // if (!this.state.updated) {
    // // this.setState({updated: true});
    // // }

    // if (placesCount === 1 && !this.props.chosenPlace || Auth.isTabletMode()) {
    //   // if (nextProps.allProducts.length == 0) {
    //   //   nextProps.getAllProducts(nextProps.places[0].id);
    //   // }
    //   // nextProps.getCategoriesHierarchy(nextProps.places[0].id);
    // }

    // Set the logo in the sub header
    //  let logoSrc ='https://theschool.tabl.bg/images/the-school-logo2.png';
    //  let img = document.createElement('img');
    //  img.src= logoSrc;
    //  img.classList.add('reservation-restaurant-logo');
    //  let headerContainer = document.querySelector('header');
    //  if (headerContainer) {
    //    headerContainer.appendChild(img);
    //  }
  }

  componentDidUpdate() {
    // Settings usually arrive after the first render, so retry configuring the
    // client's trackers here (no-op once it has run).
    this.configureClientTrackers();

    if ((localStorage.getItem('initial_translate') == 1) && this.props.settings.translations_type && this.props.settings.translations_type.value == 1 && this.props.settings.first_init_lang.value.length > 0) {
      const makeTranslation = () => {
        let element = document.querySelector('.goog-te-combo');
        if (element) {
          window.localStorage.setItem('initial_translate', 0);
          element.value = this.props.settings.first_init_lang.value;
          Utils.fireEvent(element, 'change');
        }
      }

      setTimeout(() => {
        makeTranslation();
      }, 300);
      setTimeout(() => {
        makeTranslation();
      }, 400);
      setTimeout(() => {
        makeTranslation();
      }, 500);
    }


    if (this.props.settings.default_lang && this.props.settings.default_lang.value) {
      // this.props.changeLanguage(this.props.settings.default_lang.value);

      this.props.changeLanguage(Auth.getCurrLang() || this.props.settings.default_lang.value, this.props.settings.translations_type && this.props.settings.translations_type.value || null);
    }

  }

  // handleSongFinishedPlaying = () => {
  //   this.setState({ soundStatus: Sound.status.STOPPED })
  // }

  setUtmCookie = () => {
    const incoming = captureUtmFromUrl();
    if (incoming) saveUtmToCookie(incoming);
  }

  render() {
    const { classes, isLoading, settings, places } = this.props;

    return (
      <LocalizeProvider>
        <MetaAndOg />
        {isLoading ? <CircularProgress className="is-loading" /> : null}
        {/* prevent hide url bar */}
        <div
          id="page-container"
          className={classes.pageContainer}
          data-class={[
            Auth.isTabletMode() ? "tablet-mode" : "",
            Auth.isKioskMode() ? "kiosk-mode" : ""
          ].filter(Boolean).join(" ")}
          style={{
            backgroundImage: Utils.getSettingsValue(settings, 'lighter_backgound_image') == 1 ?
              ('url(' + (settings.menu_background_image && settings.menu_background_image.value ? Utils.getSettingsPath(settings.menu_background_image.value) : '') + ')')
              : (this.props.mainBackground + ', url(' + (settings.menu_background_image && settings.menu_background_image.value ? Utils.getSettingsPath(settings.menu_background_image.value) : '') + ')'),
            overflow: 'auto',
            height: '100%'
          }} >

          {/* <Sound
              playStatus={this.state.soundStatus}
              url={soundfile}
              onFinishedPlaying={this.handleSongFinishedPlaying}
          /> */}

          {/* {placesCount > 1 ? <RouterMultiplePlaces /> : <Router />} */}
          <Router />

          <TrackTimeSpentOnPageComponent />

          {/* Банер "Добави на началния екран" (PWA) — вкл./изкл. от настройка
              show_add_to_home_screen_banner */}
          <AddToHomeScreen />
        </div>


      </LocalizeProvider>
    );
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    isLoading: state.products.isLoading || state.categories.isLoading || false,
    settings: state.settings.settings || [],
    places: state.places.places || [],
    chosenPlace: state.places.chosen_place || 0,
    currLang: state.lang.currLang,
    mainBackground: state.settings.mainBackground || 'linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) )',
    allProducts: state.products.all_products || [],

  }
};

const mapTrackingToProps = trackEvent => ({ trackPageView: (pageId, userId) => trackEvent(pageView(pageId, userId)) });


export default withTracking(mapTrackingToProps)(
  withStyles(styles)(connect(mapStateToProps, { changeLanguage, getAllProducts, getCategoriesHierarchy })(App))
)